import { Form } from "antd";
import { useMemo } from "react";
import parseDate from "utils/parseDate";

import { UseTicketAvailabilityDates } from "./types";
import { createTicketAvailabilityDate } from "./utils";

export const useTicketAvailabilityDates: UseTicketAvailabilityDates = (
  eventDate,
  form
) => {
  const [
    availableBeforeDays,
    availableBeforeTime,
    expireBeforeDays,
    expireBeforeTime,
  ] = [
    Form.useWatch("availableBeforeDays", form),
    Form.useWatch("availableBeforeTime", form),
    Form.useWatch("expireBeforeDays", form),
    Form.useWatch("expireBeforeTime", form),
  ];

  return useMemo(() => {
    const plainEventDate = parseDate(eventDate);

    if (!plainEventDate) {
      return {};
    }

    return {
      availableBeforeDate: createTicketAvailabilityDate(
        plainEventDate,
        availableBeforeTime,
        availableBeforeDays
      ),
      expireBeforeDate: createTicketAvailabilityDate(
        plainEventDate,
        expireBeforeTime,
        expireBeforeDays
      ),
    };
  }, [
    eventDate,
    availableBeforeDays,
    availableBeforeTime,
    expireBeforeDays,
    expireBeforeTime,
  ]);
};
